// extracted by mini-css-extract-plugin
module.exports = {"Placemark":"YnjMX","Placemark__Icon":"_7Wg4S"};